import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Anchor, Flex, Heading, Text, theme } from '@percent/lemonade'
import { CentralCardLayoutWrapper } from '@percent/cause-dashboard/common/components'
import Plane from '@percent/cause-dashboard/common/assets/images/paper-plane.png'
import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'
import styles from './ThanksForYourInterestPage.module.scss'
import { ReactComponent as SuccessResultBadge } from '@percent/cause-dashboard/common/assets/images/success-result-badge.svg'

export function ThanksForYourInterestPage() {
  const { t } = useTranslation()

  return (
    <CentralCardLayoutWrapper>
      <Flex direction="column" align="center" gap={theme.spacing.l}>
        <SuccessResultBadge data-testid="success-result-badge" />
        <Heading level="h2" align="center">
          {t('thanksForYourInterest.heading')}
        </Heading>
        <img src={Plane} className={styles.planeImage} alt="" />
        <Flex direction="column" align="center">
          <Text size="small" align="center">
            {t('thanksForYourInterest.body')}
          </Text>
          <Anchor
            size="sm"
            component={Link}
            to={RoutePath.HOME}
            c="var(--semantic-interactive-default)"
            underline="always"
          >
            {t('thanksForYourInterest.link')}
          </Anchor>
        </Flex>
      </Flex>
    </CentralCardLayoutWrapper>
  )
}
